import { StyleSheet, Text, Pressable, Linking, View, useWindowDimensions } from 'react-native'
import React from 'react'
import Ionicons from '@expo/vector-icons/Ionicons';
import { colors } from '../../colors'
import { displayFont } from '../../fonts'

const Footer = () => {
  const window = useWindowDimensions();
  const narrow = window.width < 768;
  const openAppStore = () => Linking.openURL('https://www.facebook.com/ivyoootv');

  return (
    <View style={[styles.container, narrow && styles.containerNarrow, narrow && { backdropFilter: 'blur(18px)', WebkitBackdropFilter: 'blur(18px)' }]}>
      <Text style={[styles.text, narrow && styles.textNarrow]}>{narrow ? '© 2022 iVYOOO, Inc.' : 'Copyright 2022 ivyooo.com  ·  iVYOOO, Inc.'}</Text>
      <View style={[styles.social, narrow && styles.socialNarrow]}>
        {!narrow && <Text style={styles.textSocial}>Follow us on </Text>}
        <Pressable accessibilityRole="link" accessibilityLabel="Follow iVYOOO on Facebook" onPress={openAppStore} style={({ focused }) => [styles.button, focused && styles.focused]}>
            <Ionicons accessibilityElementsHidden importantForAccessibility="no" name="logo-facebook" size={28} color={colors.offwhite} />
        </Pressable>
      </View>
    </View>
  )
}

export default Footer

const styles = StyleSheet.create({
    container: {
        width: '100%',
        minHeight: 60,
        backgroundColor: 'black',
        paddingLeft: 16,
        paddingRight: 16,
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    containerNarrow: {
        width: 'auto',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: 0,
        marginHorizontal: 16,
        paddingVertical: 14,
        paddingHorizontal: 16,
        backgroundColor: 'rgba(8,8,8,0.78)',
        marginBottom: 'max(16px, env(safe-area-inset-bottom))',
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.18)',
        borderRadius: 18,
        gap: 4,
    },
    textNarrow: {
        textAlign: 'center',
        flexShrink: 0,
    },
    socialNarrow: {
        marginTop: 2,
    },
    text: {
        color: colors.offwhite,
        fontFamily: displayFont,
        fontSize: 14,
        lineHeight: 18,
        letterSpacing: 0.4,
        flexShrink: 1,
    },
    focused: {
        outlineWidth: 2,
        outlineStyle: 'solid',
        outlineColor: '#FFFFFF',
        outlineOffset: 2,
    },
    button: {
        width: 44,
        height: 44,
        marginRight: 8,
        justifyContent: 'center',
        alignItems: 'center',
    },
    social: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    textSocial: {
        color: colors.offwhite,
        fontFamily: displayFont,
        fontSize: 14,
        letterSpacing: 0.4,
        paddingRight: 6,
    }
})